<template>
  <nav class="controls margins-off">
    <button
      v-if="locationsCount > 0"
      class="control"
      @click="$emit('openLocationsModal')"
    >
      <icon-save>Saved</icon-save>
      <span class="badge pill">{{ locationsCount }}</span>
    </button>
    <button
      class="control watch-control is-toggle"
      @click="$emit('watch')"
      :aria-pressed="isWatching ? 'true' : 'false'"
      :class="{ updated: hasUpdated }"
    >
      <icon-watch :animate="isWatching ? true : false"
        >Watch Location</icon-watch
      >
    </button>
    <button class="control" @click="$emit('refresh')">
      <icon-refresh :class="{ locating: isLocating }">Refresh</icon-refresh>
    </button>
    <button class="control" @click="$emit('openInformationModal')">
      <span class="icon">?</span>
    </button>
  </nav>
</template>

<script>
import IconRefresh from "@/components/icons/IconRefresh";
import IconSave from "@/components/icons/IconSave";
import IconWatch from "@/components/icons/IconWatch";

export default {
  components: {
    IconRefresh,
    IconSave,
    IconWatch
  },
  props: {
    locationsCount: Number,
    hasUpdated: Boolean,
    isLocating: Boolean,
    isWatching: Boolean
  }
};
</script>

<style lang="scss">
.controls {
  display: flex;
  justify-content: center;
}

.control {
  background-color: $color-purple;
  border: 2px solid $color-purple-highlight;
  border-radius: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  line-height: 1;
  padding: 0.25rem;
  position: relative;
  transition: border-color 0.2s ease;
  user-select: none;
  width: 3.5rem;
  height: 3.5rem;

  &:active,
  &:focus {
    border-color: $color-accent;
    outline: none;

    .pill {
      background-color: $color-accent;
      color: $color-purple;
    }
  }

  &[aria-pressed="true"] {
    border-color: $color-accent;
  }

  > span {
    display: inline-block;
    margin: 0;
  }

  &.updated {
    // background-color: white;
    animation: flash 1s ease 1;
  }

  .locating {
    animation: spin 1s linear infinite;
  }

  + .control {
    margin-left: 1em;
  }

  .icon {
    font-size: 1.25em;
  }

  .pill {
    position: absolute;
    top: -0.375em;
    right: -0.25em;
  }
}

.watch-control .icon {
  font-size: 1.75em;
}

.control[aria-pressed="true"] {
  background-color: $color-accent;
  color: $color-purple;
}
</style>
